import { render } from "./IndexMenus.vue?vue&type=template&id=13469d65"
import script from "./IndexMenus.vue?vue&type=script&lang=js"
export * from "./IndexMenus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__